import React, { useMemo } from 'react';
import { View, Text, useWindowDimensions } from 'react-native';
import CustomPressable from '../customPressable/customPressable';
import { ImageComp } from '../Image/Image';
import { useCssStyle } from '../../customHook/getCssStyle';
import { getCleanUrl } from '../../utils/Helper';
import RenderHTML from 'react-native-render-html';
import { useDispatch, useSelector } from 'react-redux';
import { EARLY_CHECKIN, PRE_CHECKIN } from '../../config/Constant';
import { formatTime } from '../../js/formatTime';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';
import { CHECK_IN } from '../../navigation/StackNavigator/routes';
import { setShowLoginModal } from '../../Redux/Reducers/appConfigReducer';
import SliderPressable from '../customPressable/sliderPressable';
import { inAppBrowserFunc } from '../../js/inAppBrowser/inAppBrowser';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';
import { setGuestRoomData } from '../../Redux/Reducers/guestRoomReducer';


const GuestDetailsWidget = (props) => {
  const { widget, listItemData = [], handleOnWidgetClick } = props || {};
  const getStyles = useCssStyle();
  const { width } = useWindowDimensions()
  const { t } = useTranslation();
  const navigation = useNavigation();
  const dispatch = useDispatch();

  const { isLoggedIn } = useSelector(state => state.appConfigSlice);
  const { preCheckInCompleted, preCheckInData } = useSelector(state => state.checkInSlice.preCheckInStatus);
  const { preCheckInWidgetState } = useSelector(state => state.checkInSlice);

  const { webAppWidgetsInfo } = useSelector((state) => state.deviceConfigSlice);
  
  const { bookYourStayLink, allowUserLoginViaFindingReservation } = webAppWidgetsInfo?.appConfigs || {};

  const { isBookingFound, bookingData } = useSelector(state => state.checkInSlice.bookingStatus);



  const proceedCheckIn = () => {
    navigation.navigate(CHECK_IN, { attemptCheckin: true });
  }

  const proceedCheckInWidget = () => {
    navigation.navigate(CHECK_IN);
  }

  const handleMakeRes = () => {
    if(bookYourStayLink){
      inAppBrowserFunc(bookYourStayLink);
    } else {
      dispatch(setRenderFlashMessage(true, { type: "danger", message: "Booking link is unavailable." }));
    }
  }

  const handleLinkToRoom = () => {
    dispatch(setGuestRoomData({
        guestDetails: bookingData,
        activeState: 'get_login_roomnumber'
    }));
    dispatch(setShowLoginModal(true));
  }

  if (!listItemData.length) {
    return null;
  }

  return (
    <>
      {
        listItemData.map(widgetData => {
          let widgetImg = widgetData.btnImageUrl ? getCleanUrl(widgetData.btnImageUrl) : null;
          const customWidgetTitleStyle = getStyles([
            'guestDetailsHeaderTitle',
            `guestDetailsHeaderTitle_${widgetData.widgetMetaHtmlId}`,
            `guestDetailsHeaderTitle_${widgetData.id}`
          ]);


          const customWidgetSubTitleStyle = getStyles([
            'guestDetailsHeaderSubtitle',
            `guestDetailsHeaderSubtitle_${widgetData.widgetMetaHtmlId}`,
            `guestDetailsHeaderSubtitle_${widgetData.id}`
          ]);

          return (
            <View key={widgetData.id} style={getStyles(['guestDetailsWidgetContainer', `guestDetailsWidgetContainer_${widgetData.widgetMetaHtmlId}`, `guestDetailsWidgetContainer_${widgetData.id}`])} id={`guestDetailsWidgetContainer guestDetailsWidgetContainer_${widgetData.widgetMetaHtmlId} guestDetailsWidgetContainer_${widgetData.id}`} >
              {widgetImg && (
                <ImageComp
                  source={widgetImg}
                  style={getStyles(['guestDetailsImageStyle', `guestDetailsImageStyle_${widgetData.widgetMetaHtmlId}`, `guestDetailsImageStyle_${widgetData.id}`])}
                  id={`guestDetailsImageStyle guestDetailsImageStyle_${widgetData.widgetMetaHtmlId} guestDetailsImageStyle_${widgetData.id}`}
                />
              )}
              {widgetData.widgetTitle && (
                <RenderHTML
                  contentWidth={width}
                  baseStyle={customWidgetTitleStyle}
                  source={{ html: widgetData.widgetTitle }}
                  systemFonts={[customWidgetTitleStyle.fontFamily]}
                  id={`guestDetailsHeaderTitle guestDetailsHeaderTitle_${widgetData.widgetMetaHtmlId} guestDetailsHeaderTitle_${widgetData.id}`}
                />
              )}
              {widgetData.widgetDesc && (
                <View style={customWidgetSubTitleStyle}>
                  <RenderHTML
                    contentWidth={width}
                    baseStyle={customWidgetSubTitleStyle}
                    source={{ html: widgetData.widgetDesc }}
                    systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                    id={`guestDetailsHeaderSubtitle guestDetailsHeaderSubtitle_${widgetData.widgetMetaHtmlId}`}

                  />
                </View>
              )}
              {
                isLoggedIn ? null :
                  preCheckInCompleted ?

                    <View style={getStyles(['guestDetailsButtonContainer'])} >
                      <SliderPressable disabled={preCheckInWidgetState == PRE_CHECKIN} text={preCheckInWidgetState == EARLY_CHECKIN ? t('guest_details.request_early_checkin') : t('guest_details.proceed_checkin')} handleOnSuccess={proceedCheckIn} />

                      {<>
                          <Text style={getStyles(['guestDetailsButtonContainerText'])}>{t('guest_details.have_room')}</Text>

                          <CustomPressable onPress={handleLinkToRoom} style={getStyles(['secondaryBtn'])}>
                            <Text style={getStyles(['secondaryBtnTxt'])}>{t('guest_details.link_to_room')}</Text>
                          </CustomPressable>
                      </>}
                    </View>
                    :
                    isBookingFound ?
                      <View style={getStyles(['guestDetailsButtonContainer'])} >
                        <SliderPressable text={t('guest_details.proceed_pre_checkin')} handleOnSuccess={proceedCheckInWidget} />

                        {<>
                          <Text style={getStyles(['guestDetailsButtonContainerText'])}>{t('guest_details.have_room')}</Text>

                          <CustomPressable onPress={handleLinkToRoom} style={getStyles(['secondaryBtn'])}>
                            <Text style={getStyles(['secondaryBtnTxt'])}>{t('guest_details.link_to_room')}</Text>
                          </CustomPressable>
                        </>}
                      </View>
                      :
                      <View style={getStyles(['guestDetailsButtonContainer'])} >
                        <CustomPressable style={getStyles(['primaryBtn'])} onPress={() => dispatch(setShowLoginModal(true))}>
                          <Text style={getStyles(['primaryBtnTxt'])}>{allowUserLoginViaFindingReservation ? t('guest_details.find_reservation') : t('guest_details.link_to_room')}</Text>
                        </CustomPressable>

                        {bookYourStayLink &&
                          <>
                            <Text style={getStyles(['guestDetailsButtonContainerText'])}>{t('guest_details.have_booking')}</Text>

                            <CustomPressable onPress={handleMakeRes} style={getStyles(['secondaryBtn'])}>
                              <Text style={getStyles(['secondaryBtnTxt'])}>{t('guest_details.make_reservation')}</Text>
                            </CustomPressable> 
                          </>
                        }
                      </View>
              }
            </View>
          )
        })
      }
    </>
  );
};

export default React.memo(GuestDetailsWidget);